<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">Delete Historical Data
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>

<hr class="my-0">

<mat-dialog-content>
    <div class="p-5" *ngIf="step === 1">
        Are you sure you want to delete this item?
    </div>
    <div class="p-5" *ngIf="step === 2">
        This action cannot be undone. Are you sure you want to proceed?
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>Cancel</button>
    <button *ngIf="step === 1" class="btn btn-error text-white" (click)="nextStep()">
        Delete
    </button>
    <button *ngIf="step === 2" class="btn btn-error text-white" [disabled]="isLoading" (click)="confirmDelete()">
        <span *ngIf="isLoading" class="loading loading-ring loading-sm"></span>
        Confirm
    </button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>